/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, color } from 'utils/styles';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// HORIZONTAL STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
	bar: {

	},
	inner: {
		display: 'block',
		width: '100%',
		height: '100%',
		'& .bar': {
			transition: 'width .8s linear 0s, background .3s linear 0s'
		},
		'& .bar.foreground': {
			background: 'rgba(25,25,25,0.70)'
		},
		'&.selected-true': {
            	'& .bar.background': { background: color.brand, opacity: '.3' },
            	'& .bar.foreground': { background: color.brand, opacity: '.9' },
			'&.correct-false': {
				'& .bar.background': { background: '#872323', opacity: '.3' },
				'& .bar.foreground': { background: '#a53636' }
			},
			'&.correct-true': {
				'& .bar.background': { background: '#25661b', opacity: '.3' },
				'& .bar.foreground': { background: '#63913f' },
			},
		},
		'&.selected-false': {
			'&.finished-true': {
				'&.correct-true': {
					'& .bar.background': { background: '#25661b', opacity: '.3', transitionDelay: '1.6s' },
					'& .bar.foreground': { background: '#63913f', transitionDelay: '1.6s' }
				}
			}
		}
	},
	background: {
		display: 'block',
		position: 'absolute',
		bottom: '0',
		left: '0',
		width: '100%',
		height: '100%',
		zIndex: '1'
	},
	foreground: {
		display: 'block',
		position: 'absolute',
		bottom: '0',
		left: '0',
		width: '0%', // dynamic, should come from component
		height: '100%',
		zIndex: '2'
	},
	number: {
		position: 'absolute',
		top: '50%',
		right: pxToEm(15),
		fontSize: '80%', // should be same as what we animate the answer text to in text2_styles
		transform: 'translateY(-50%)',
		zIndex: '3'
	}
};
